<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-6">1. Your company</h5>
                <h2>{{ brand }} in a nutshell.</h2>
                <h4>This will help us create your company page.</h4>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-lg-6 col-md-8 col-sm-12">
                <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                    <avatar-uploader placeholder="supplier" @uploadComplete="addUploadedAvatar"></avatar-uploader>

                    <div class="form-group mb-2">
                        <label class="full">
                            Email (for customer contact)<span class="brand ml-1">*</span>
                            <input v-model="form.companyEmail" type="email" placeholder="Please add your email">
                        </label>

                        <div v-if="$v.form.companyEmail.$invalid" class="error">
                            <span v-if="!$v.form.companyEmail.required">Email (for customer contact) is required.</span>
                            <span v-if="!$v.form.companyEmail.email">Must be a valid email</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-2">
                                <label class="full">
                                    Phone (for customer contact)<span class="brand ml-1">*</span>
                                </label>
                                <PhoneInput
                                    ref="phoneInput"
                                    v-model="form.companyPhone"
                                    @input="onPhoneInput"
                                    @validate="isPhoneValid"
                                />
                                <div class="error">
                                    <span v-if="!form.companyPhone">Phone number is required.</span>
                                    <span v-else-if="companyPhoneValid === false">Phone Number Invalid.</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <div class="form-group mb-2">
                                <label class="full">
                                    Website
                                    <input v-model="form.website" type="text" placeholder="www.website.com">
                                </label>

                                <div v-if="$v.form.website.$invalid" class="error">
                                    <span v-if="!$v.form.website.isWebsiteValid">Must be a valid website.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mb-1">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.supplier' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>
                        
                        <div class="col-md-6">
                            <button
                                type="submit"
                                class="btn action widest full"
                                value="Finish"
                                :disabled="$v.$invalid || submittingRegistration || companyPhoneValid === false"
                            >
                                <loader v-if="submittingRegistration"></loader>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { mapActions, mapGetters } from 'vuex'

    import validationsMixin from '@/mixins/validationHelpers' 
    import loader from '@/tools/loaders/loader1'
    import AvatarUploader from '../../common/AvatarUploader'
    import extendedVSelect from '@/extends/vue-select'
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import phoneCountrySync from '@/mixins/phoneCountrySync'

    export default {
        mixins: [ validationsMixin, phoneCountrySync ],
        data() {
            return {
                step: 2,
                form: {
                    companyEmail: '',
                    companyPhone: '',
                    companyURL: '',
                    website: '',
                    imageLogoBase64: null
                },
                selectedOfferType: null,
                submittingRegistration: false,
                companyPhoneValid: true
            }
        },
        validations: {
            form: {
                companyEmail: {
                    required,
                    email,
                },
                companyPhone: {
                    required,
                },
                website: {
                    isWebsiteValid(val) {
                        return !val || this.isValid(val, 'website');
                    }
                },
            },
        },
        created() {
            // Redirect if we landed here without having passed through the needed steps
            if (this.accountSetup.type !== 'supplier') {
                this.resetAccountSetup('supplier');
                this.$router.push({ name: 'auth.signup' });
            } else {
                this.form.tagline = this.accountSetup.tagline || '';
                this.form.companyURL = this.accountSetup.companyURL || '';
                this.eventHub.$emit('sidebar', 'create');
                this.eventHub.$emit('topLink', 'login');
            }
        },
        computed: {
            ...mapGetters(['accountSetup','getCountries']),
        },
        asyncComputed: {
            brand() {
                return this.accountSetup.brand || '';
            }
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'registerSupplier'
            ]),
            processForm() {
                if (!this.submittingRegistration) {
                    this.form.step = this.step + 1;

                    // Update account setup data
                    this.updateAccountSetup(this.form);

                    // Create a supplier account via API
                    this.submittingRegistration = true;
                    
                    this.registerSupplier({
                        parsed: this.parseQueryString(this.accountSetup),
                        json: this.accountSetup
                    }).then(() => {
                        this.submittingRegistration = false;
                        this.resetAccountSetup('supplier');
                    });

                } else {
                    this.$toasted.info('Already submitting your registration, please wait');
                }
            },
            addUploadedAvatar(avatar) {
                this.form.imageLogoBase64 = avatar;
            },
            isPhoneValid(phoneObj) {
                this.companyPhoneValid = !!phoneObj.valid;
            },
        },
        components: {
            loader,
            vSelect: extendedVSelect,
            AvatarUploader,
            PhoneInput
        }
    }
</script>

<style lang="scss" scoped>
    .form-group {
        min-height: 4.75rem;
    }

    label.full {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// Step2.vue?f531041c